/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_SearchInputs */

const cs_deals_search = /** @type {(inputs: Deals_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat`)
};

const en_deals_search = /** @type {(inputs: Deals_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Deals_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_search = /** @type {((inputs?: Deals_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_search(inputs)
	return cs_deals_search(inputs)
});